import React from "react";
// TODO => mettre l'avatar des sujets
const Header = () => {
    return (
        <header>
            <div className="banner-container">
                <h1><a href="/welcome">Plateforme Altruisme</a></h1>
            </div>
        </header>
    )
}

export default Header